<div class="item-page-field">
  <ds-metadata-mixed-uri-values [mdValues]="item?.allMetadata(fields)" [separator]="separator" [label]="label"></ds-metadata-mixed-uri-values>
</div>
